export const sidebar = [
  {
    id: "1",
    icon: "el-icon-user-solid",
    text: "首页",
    name:'首页',
    url: "/"
  },
  {
    id: "2",
    icon: "el-icon-s-promotion",
    text: "项目",
    name:'项目',
    url: "/projects"
  }
];
